module.exports = __webpack_public_path__ + "static/m-JorgeVelazquez-b80c1c25f7a85f0316cedeb80a3dea2e.jpg";